import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { get } from 'lodash';

import { articlize } from '../../../../utils/a-or-an';
import { procedureShape, specialtyShape } from '../../../../constants';
import ModalView from '../../ModalView';
import RefineProcedureModal from '../RefineProcedureModal';

import * as ModalConstants from '../constants';

class BaseConstraintModalContainer extends Component {
    static propTypes = {
        modalType: PropTypes.number,
        primaryActionHref: PropTypes.string,
        onClickCancel: PropTypes.func,
        onClickPrimaryAction: PropTypes.func,
        onClickSecondaryAction: PropTypes.func,
        provider: PropTypes.object,
        searchSpecialty: specialtyShape,
        searchProcedure: procedureShape,
        updateParameters: PropTypes.func,
    };

    static defaultProps = {
        searchSpecialty: {},
        searchProcedure: {},
        provider: {},
    };

    render() {
        const {
            intl,
            provider,
            searchSpecialty,
        } = this.props;

        const {
            LOCALIZED_ADDITIONAL_COPAY_TEXT,
            LOCALIZED_ASSISTANT_TEXT,
            LOCALIZED_CROSS_LISTED_TEXT,
            LOCALIZED_MODAL_PRIMARY_ACTION_TEXT,
            LOCALIZED_MODAL_SECONDARY_ACTION_TEXT,
            LOCALIZED_NATUROPATHIC_TEXT,
            LOCALIZED_OBGYN_TEXT,
            LOCALIZED_PEDIATRIC_TEXT,
            LOCALIZED_PHYSICIAN_ASSISTANT_TEXT,
            LOCALIZED_REFINE_PROCEDURE_TEXT,
            LOCALIZED_URGENT_CARE_TEXT,
            ModalTypeIds,
        } = ModalConstants;

        const relevantSpecialtyWithArticle = articlize(get(provider, 'relevantSpecialty.name'));
        const searchSpecialtyWithArticle = articlize(get(searchSpecialty, 'name'));

        let header = '';
        let message = '';
        let additionalMessage = '';
        let primaryActionText = '';
        let secondaryActionText = intl.formatMessage(LOCALIZED_MODAL_SECONDARY_ACTION_TEXT.DEFAULT);

        if (this.props.modalType === ModalTypeIds.REFINE_PROCEDURE) {
            header = intl.formatMessage(LOCALIZED_REFINE_PROCEDURE_TEXT.HEADER, {
                provider: provider.nameInSentence,
            });
            message = intl.formatMessage(LOCALIZED_REFINE_PROCEDURE_TEXT.MESSAGE);
            primaryActionText = intl.formatMessage(LOCALIZED_MODAL_PRIMARY_ACTION_TEXT.BOOK_APPOINTMENT);

            return (
                <RefineProcedureModal
                    header={header}
                    message={message}
                    onClickCancel={this.props.onClickCancel}
                    onClickPrimaryAction={this.props.onClickPrimaryAction}
                    onClickSecondaryAction={this.props.onClickSecondaryAction}
                    primaryActionHref={this.props.primaryActionHref}
                    primaryActionText={primaryActionText}
                    provider={this.props.provider}
                    secondaryActionText={secondaryActionText}
                    specialtyId={get(provider, 'relevantSpecialty.id')}
                    updateParameters={this.props.updateParameters}
                />
            );
        }

        switch (this.props.modalType) {
            case ModalTypeIds.ADDITIONAL_COPAY: {
                header = intl.formatMessage(LOCALIZED_ADDITIONAL_COPAY_TEXT.HEADER);
                primaryActionText = intl.formatMessage(LOCALIZED_MODAL_PRIMARY_ACTION_TEXT.BOOK_APPOINTMENT);
                break;
            }

            case ModalTypeIds.CROSS_LISTED: {
                header = intl.formatMessage(LOCALIZED_CROSS_LISTED_TEXT.HEADER, {
                    relevantSpecialtyWithArticle,
                });
                message = intl.formatMessage(LOCALIZED_CROSS_LISTED_TEXT.MESSAGE, {
                    provider: provider.nameInSentence,
                    searchSpecialtyWithArticle,
                    relevantSpecialtyWithArticle,
                    procedure: this.props.searchProcedure.name,
                });
                primaryActionText = intl.formatMessage(LOCALIZED_MODAL_PRIMARY_ACTION_TEXT.YES);
                break;
            }

            case ModalTypeIds.NATUROPATHIC: {
                header = intl.formatMessage(LOCALIZED_NATUROPATHIC_TEXT.HEADER);
                message = intl.formatMessage(LOCALIZED_NATUROPATHIC_TEXT.MESSAGE, {
                    provider: provider.approvedFullName,
                });
                primaryActionText = intl.formatMessage(LOCALIZED_MODAL_PRIMARY_ACTION_TEXT.YES);
                break;
            }

            case ModalTypeIds.OBGYN: {
                header = intl.formatMessage(LOCALIZED_OBGYN_TEXT.HEADER);
                message = intl.formatMessage(LOCALIZED_OBGYN_TEXT.MESSAGE, {
                    provider: provider.approvedFullName,
                });
                primaryActionText = intl.formatMessage(LOCALIZED_MODAL_PRIMARY_ACTION_TEXT.YES);
                break;
            }

            case ModalTypeIds.PEDIATRIC: {
                header = intl.formatMessage(LOCALIZED_PEDIATRIC_TEXT.HEADER);
                message = intl.formatMessage(LOCALIZED_PEDIATRIC_TEXT.MESSAGE, {
                    provider: provider.nameInSentence,
                });
                primaryActionText = intl.formatMessage(LOCALIZED_MODAL_PRIMARY_ACTION_TEXT.YES);
                break;
            }

            case ModalTypeIds.PHYSICIAN_ASSISTANT: {
                header = intl.formatMessage(LOCALIZED_PHYSICIAN_ASSISTANT_TEXT.HEADER);
                message = intl.formatMessage(LOCALIZED_PHYSICIAN_ASSISTANT_TEXT.MESSAGE, {
                    provider: provider.approvedFullName,
                    procedure: this.props.searchProcedure.name,
                });
                primaryActionText = intl.formatMessage(LOCALIZED_MODAL_PRIMARY_ACTION_TEXT.BOOK_APPOINTMENT);
                break;
            }

            case ModalTypeIds.URGENT_CARE: {
                header = intl.formatMessage(LOCALIZED_URGENT_CARE_TEXT.HEADER);
                message = intl.formatMessage(LOCALIZED_URGENT_CARE_TEXT.MESSAGE);
                additionalMessage = intl.formatMessage(LOCALIZED_URGENT_CARE_TEXT.ADDITIONAL_MESSAGE);
                primaryActionText = intl.formatMessage(LOCALIZED_MODAL_PRIMARY_ACTION_TEXT.BOOK_APPOINTMENT);
                break;
            }

            case ModalTypeIds.ASSISTANT: {
                message = intl.formatMessage(LOCALIZED_ASSISTANT_TEXT.MESSAGE, {
                    provider: provider.approvedFullName,
                });
                primaryActionText = intl.formatMessage(LOCALIZED_MODAL_PRIMARY_ACTION_TEXT.OK_CONTINUE_BOOKING);
                secondaryActionText = intl.formatMessage(LOCALIZED_MODAL_SECONDARY_ACTION_TEXT.CANCEL);
                break;
            }
        }

        return (
            <ModalView
                additionalMessage={additionalMessage}
                header={header}
                message={message}
                onClickCancel={this.props.onClickCancel}
                onClickSecondaryAction={this.props.onClickSecondaryAction}
                primaryActionHref={this.props.primaryActionHref}
                primaryActionText={primaryActionText}
                secondaryActionText={secondaryActionText}
            />
        );
    }
}

export default injectIntl(BaseConstraintModalContainer);
